import React from 'react';
import commonUtil from '../../utils/commonUtil';
import { closeIcon, errorIcon, successIcon, warningIcon, errorCloseIcon, successCloseIcon } from './svgs/icons';

const channel = commonUtil.getChannel();
const alertColor = {
  error: '#B50000',
  warning: '#cb8e13',
  success: 'var(--Semantic-Success-700, #07862C)',
};

class Warning2 extends React.Component {
  state = {
    alertMessage: '',
    type: 'warning',
    showCloseIcon: true,
  };

  componentDidMount() {
    const { textMessage } = this.props || {};
    if (typeof textMessage === 'string') this.cbTextMessage(textMessage);
  }

  componentWillUnmount() {
    clearTimeout(this.time);
  }

  hideAlertMsgFn = () => {
    if (this.errormsg) {
      this.errormsg.style.display = 'none';
    }
    this.setState({ ...this.state, alertMessage: '' });
  }

  cbTextMessage = textMessage => this.setState({ ...this.state, alertMessage: textMessage });

  setMessage = (message,showCloseIcon=true) => {
    this.setState({ ...this.state, alertMessage: message, showCloseIcon });
    if (message && !this.props.notSetToTop) {
      commonUtil.goToTop();
    }
  }

  setAutomaticClose = () =>
    this.time = setTimeout(() => this.hideAlertMsgFn(), 5000);

  alertIcon = ({
    error: errorIcon,
    warning: warningIcon,
    success: successIcon,
  });

  setType = type => this.setState({ ...this.state, type })

  render() {
    if (!this.state.alertMessage) return null;
   // if (this.props.onClose) 
      this.setAutomaticClose();

    const type = this.props.type || this.state.type || '';
    const style = this.props.style;
    const spanStyle = this.props.spanStyle || {}  ;

    const newStyles = {
      width: '100%',
      alignSelf: 'center',
      border: '0',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '8px 12px',
      backgroundColor: type === 'success' ? '#E7F8EC' : `#F8E7E7`,
      borderRadius: 4,
      boxShadow: '3px 6px 12px 0px rgba(21, 21, 21, 0.12)',
      height: 48,
      ...style,
    };

    const closeIconStyle = ({
      cursor: 'pointer',
      color: alertColor[type],
    });

    const stylesContainer = ({
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
    });

    const wapStyles =  ({
      marginTop: 6
    })

    const alertTextStyle = ({
      color: alertColor[type],
      fontSize: 12,
      fontWeight: 600,
      lineHeight: '15.6px',
      height: 16,
      ...spanStyle
    });

    return (
      <div
        className={`alert${type[0] && type[0].toLowerCase()}${type.slice(1)}`}
        ref={errormsg => this.errormsg = errormsg}
        style={{
          ...newStyles,
          ...(channel === 'wap' ? wapStyles : {})
        }}
      >
        <div
          style={{
            color: alertColor[type],
            ...stylesContainer,
          }}
        >
          <span className='event-success-close wap_gift_success'>{this.alertIcon[type]}</span>
          <span style={alertTextStyle} className='alert-message-wap-warning2' dangerouslySetInnerHTML={{ __html: this.state.alertMessage }} />
        </div>
        {this.state.showCloseIcon && 
          <div style={closeIconStyle} onClick={this.hideAlertMsgFn} className='event-success-close wap_gift_success'>
            { type === 'error' ? errorCloseIcon : type === 'success' ? successCloseIcon : closeIcon }
          </div>
        }
      </div>);
  }
}

export default Warning2;

